import request from './adminRequest'

export const appliedConsultingApi = {
  listAppliedConsulting (params) {
    return request.get('/appliedConsultings/', { params: params })
  },
  getAppliedConsulting (id) {
    return request.get('/appliedConsultings/' + id)
  },
  processAppliedConsulting (id, data) {
    return request.put('/appliedConsultings/' + id, data)
  },
  deleteAppliedConsulting (id) {
    return request.delete('/appliedConsultings/' + id)
  },

}
export default appliedConsultingApi
